"use client"

import { portfolioData } from "@/data/portfolioData"

export const Footer = () => {
  const year = new Date().getFullYear()

  return (
    <footer className="py-2 px-2 text-center border-t border-gray-200 dark:border-gray-800">
      <p className="text-sm text-muted-foreground">
        © {year} {portfolioData.personal_info.name}.
        <br />
        Built with Next.js, shadcn/ui & Tailwind CSS &mdash; v{process.env.NEXT_PUBLIC_APP_VERSION}
      </p>
    </footer>
  )
}
